export default __webpack_public_path__ + "static/media/skyblue.0cc89a5a.svg";